/* eslint-disable no-unused-vars */
import { useEffect, useState, useContext, useCallback } from 'react';
import { Switch } from '@headlessui/react';
import { useNavigate } from 'react-router-dom';
import { useLogout } from '../hooks/useLogout';
import SidebarLogo from '../assets/images/new-shoorah-logo.svg';
import { errorToast, getDeviceToken, getLocalStorageItem } from '../utils/helper';
import Menu from './Menu';
import { Api } from '../api';
import userIcon from '../assets/images/Users.svg';
import moonIcon from '../assets/images/moon.svg';
import darkMoonIcon from '../assets/images/dark-moon.svg';
import logOutIcon from '../assets/images/logout.svg';
import darkLogOutIcon from '../assets/images/dark-logout.svg';
import { SidebarContext } from '../context/SidebarContext';
import NavIcon from './NavIcon';

import darkuserIcon from '../assets/images/DarkUsers.svg';
import { useLocation } from 'react-router-dom';
import { CompanyApi } from '../api/companyApi';

//import adminDark from '../assets/images/sidebar/dark-admins.svg';
//import admin from '../assets/images/sidebar/admins.svg';import adminActive from '../assets/images/sidebar/active-admins.svg';
//guidance

import { LeftSidebarData } from '../utils/pageContent';
import { isPathUnder, matchesEntry } from '../utils/routeMatch';
import { BUILD_TYPE } from '../core/env.configs';
import Icons from '../component/svgs/icons';

function NewSidebar({ slide }) {
  const location = useLocation();
  const navigate = useNavigate();
  const [subsData, setSubsData] = useState(null);
  const [activeIndex, setActiveIndex] = useState(0);
  const [sidebarData, setSidebarData] = useState([]);
  const [activeIndexAlt, setActiveIndexAlt] = useState(0);
  const { requestLogout, logoutConfirm } = useLogout();
  //   const [openedSubMenuIndex, setOpenedSubMenuIndex] = useState(null);
  const {
    isDarkModeEnabled,
    setIsDarkModeEnabled,
    isB2BFansMode,
    setIsB2BFansMode,
    showMemberOptions,
    isCollapsed,
    setIsCollapsed
  } = useContext(SidebarContext);
  const userData = getLocalStorageItem('userData') && JSON.parse(getLocalStorageItem('userData'));

  const [openedSubMenus, setOpenedSubMenus] = useState([]);

  /**
   * Which of the sidebar's three shapes is on screen.
   *
   *   < md   a drawer over the page, opened by the toggle — a phone has no
   *          width to give a sidebar permanently
   *   md–lg  a permanent 76px rail; labels live in the flyout panels
   *   >= lg  the full sidebar, narrowed to the rail on request
   *
   * Measured once here and passed down, because every menu entry needs the
   * answer and a resize listener per entry would be dozens of them.
   */
  const [viewport, setViewport] = useState(() =>
    typeof window === 'undefined' ? 1280 : window.innerWidth
  );

  useEffect(() => {
    const onResize = () => setViewport(window.innerWidth);
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, []);

  const isDesktop = viewport >= 1024;
  const isTablet = viewport >= 768 && viewport < 1024;
  // Both widths keep the sidebar on screen, so both can show it either way.
  const canToggle = isTablet || isDesktop;

  /**
   * A tablet opens on the rail, because 250px of a 768px screen is a third of
   * it — but only as a starting point, not a rule. The toggle works there too,
   * so the labels are one tap away when someone wants them.
   *
   * Applied once per arrival at tablet width rather than on every render, or
   * it would fight anyone who expanded it.
   */
  const [railDefaulted, setRailDefaulted] = useState(false);

  useEffect(() => {
    if (isTablet && !railDefaulted) {
      setIsCollapsed(true);
      setRailDefaulted(true);
    } else if (!isTablet && railDefaulted) {
      setRailDefaulted(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isTablet]);

  const rail = isCollapsed && canToggle;

  const showBenefits = localStorage.getItem('showBenefits');
  const buildType = process.env.REACT_APP_BUILD_TYPE;
  useEffect(() => {
    if (userData?.id) {
      if (userData?.userType === 3) {
        setSidebarData([
          {
            name: LeftSidebarData.adminParentMenu.dashboard,
            href: `/${userData?.slug}/dashboard`,
            navIcon: 'dashboard',
            access: true
          },
          {
            name: LeftSidebarData.adminParentMenu.admin,
            href: `/${userData?.slug}/dashboard`,
            dropDownHref: 'isDropDown',
            navIcon: 'admin',
            access: true,
            isDropDown: true,
            subMenu: [
              {
                name: LeftSidebarData.adminParentMenu.contentApproval,
                href: `/${userData?.slug}/content-approval`,
                navIcon: 'approval',
                access: !userData?.userType,
                show: true
              },
              {
                name: LeftSidebarData.adminParentMenu.myCompany,
                href: `/${userData?.slug}/myCompany`,
                navIcon: 'company',
                access: true,
                show: true
              },
              {
                name: LeftSidebarData.adminParentMenu.report,
                href: `/${userData?.slug}/report`,
                navIcon: 'report',
                access: true,
                remove: subsData?.account !== 'Expired' ? false : true,
                show: true
              }
            ]
          },
          {
            name: LeftSidebarData.peopleManagementParentMenu.peopleManagement,
            dropDownHref: 'isDropDown',
            navIcon: 'people',
            access: true,
            isDropDown: true,
            subMenu: [
              {
                name: LeftSidebarData.peopleManagementParentMenu.users,
                href: `/${userData?.slug}/users`,
                navIcon: 'users',
                access: true,
                remove: subsData?.account !== 'Expired' ? false : true,
                show: true
              },
              {
                name: LeftSidebarData.peopleManagementParentMenu.subAdmins,
                href: `/${userData?.slug}/sub-admins`,
                navIcon: 'staff',
                access: true,
                remove: subsData?.account !== 'Expired' ? false : true,
                show: true
              },
              ...(process.env.REACT_APP_PARENT_COMPANY_ID == userData?.companyId
                ? [
                    {
                      name: LeftSidebarData.peopleManagementParentMenu.childCompanies,
                      href: `/${userData?.slug}/child-companies`,
                      navIcon: 'company',
                      access: true,
                      remove: subsData?.account !== 'Expired' ? false : true,
                      show: true
                    }
                  ]
                : []),
              {
                name: LeftSidebarData.peopleManagementParentMenu.peoplePlan,
                href: `/${userData?.slug}/people-plan`,
                navIcon: 'peoplePlan',
                access: true,
                show: false
              }
              // {
              //   name: LeftSidebarData.peopleManagementParentMenu.teamChallanges,
              //   href: `/${userData?.slug}/team-challanges`,
              //   icon: teamChallenges,
              //   activeIcon: activeTeamChallenges,
              //   darkIcon: darkTeamChallenges,
              //   access: true,
              //   show: true
              // }
            ]
          },
          {
            name: LeftSidebarData.featuresAndToolsParentMenu.featuresAndTools,
            dropDownHref: 'isDropDown',
            navIcon: 'tools',
            access: true,
            isDropDown: true,
            subMenu: [
              {
                name: LeftSidebarData.featuresAndToolsParentMenu.pulseSurveys,
                href: `/${userData?.slug}/pulse-survey`,
                navIcon: 'pulseSurvey',
                access: true,
                show: true
              },

              {
                name: 'Perks',
                href: `/${userData?.slug}/offering`,
                navIcon: 'perks',
                access: true,
                show: !isB2BFansMode
              },
              {
                name: LeftSidebarData.featuresAndToolsParentMenu.badges,
                href: `/${userData?.slug}/badges`,
                navIcon: 'badges',
                access: true,
                remove: subsData?.account !== 'Expired' ? false : true,
                show: true
              },

              {
                name: 'Challenges',
                href: `/${userData?.slug}/challenges`,
                navIcon: 'challenges',
                access: true,
                show: true
              },

              {
                name: LeftSidebarData.featuresAndToolsParentMenu.integrations,
                href: `/${userData?.slug}/integrations`,
                navIcon: 'integrations',
                access: true,
                remove: subsData?.account !== 'Expired' ? false : true,
                show: !isB2BFansMode
              },
              {
                name: LeftSidebarData.featuresAndToolsParentMenu.solutions,
                href: `/${userData?.slug}/solution`,
                navIcon: 'solutions',
                access: true,
                remove: subsData?.account !== 'Expired' ? false : true,
                show: true
              },
              {
                name: LeftSidebarData.featuresAndToolsParentMenu.pushNotifications,
                href: `/${userData?.slug}/push-notification`,
                navIcon: 'notifications',
                access: true,
                remove: subsData?.account !== 'Expired' ? false : true,
                show: true
              },

              {
                name: LeftSidebarData.featuresAndToolsParentMenu.benefits,
                href: `/${userData?.slug}/benefits`,
                navIcon: 'benefits',
                access: true,
                show: JSON.parse(localStorage.getItem('showBenefits'))
              },
              {
                name: 'Marketplace',
                href: `/${userData?.slug}/marketplace`,
                navIcon: 'marketplace',
                access: true,
                show: true
              },
              {
                name: 'Shoutouts',
                href: `/${userData?.slug}/shoutouts`,
                navIcon: 'shoutouts',
                access: true,
                show: true
              }
            ]
          }
        ]);
      } else if (userData?.userType === 4) {
        setSidebarData([
          {
            name: LeftSidebarData.adminParentMenu.dashboard,
            href: `/${userData?.slug}/dashboard`,
            navIcon: 'dashboard',
            access: true
          },
          {
            name: LeftSidebarData.adminParentMenu.admin,
            href: `/${userData?.slug}/dashboard`,
            dropDownHref: 'isDropDown',
            navIcon: 'admin',
            access: true,
            isDropDown: true,
            subMenu: [
              {
                name: LeftSidebarData.adminParentMenu.myCompany,
                href: `/${userData?.slug}/myCompany`,
                navIcon: 'company',
                access: true,
                show: true
              },
              {
                name: LeftSidebarData.adminParentMenu.report,
                href: `/${userData?.slug}/report`,
                navIcon: 'report',
                access: true,
                remove: subsData?.account !== 'Expired' ? false : true,
                show: true
              }
            ]
          },
          {
            name: LeftSidebarData.peopleManagementParentMenu.peopleManagement,
            dropDownHref: 'isDropDown',
            navIcon: 'people',
            access: true,
            isDropDown: true,
            subMenu: [
              {
                name: LeftSidebarData.peopleManagementParentMenu.users,
                href: `/${userData?.slug}/users`,
                navIcon: 'users',
                access: true,
                remove: subsData?.account !== 'Expired' ? false : true,
                show: true
              },
              {
                name: LeftSidebarData.peopleManagementParentMenu.peoplePlan,
                href: `/${userData?.slug}/people-plan`,
                navIcon: 'peoplePlan',
                access: true,
                show: false
              }
              // {
              //   name: LeftSidebarData.peopleManagementParentMenu.teamChallanges,
              //   href: `/${userData?.slug}/team-challanges`,
              //   icon: teamChallenges,
              //   activeIcon: activeTeamChallenges,
              //   darkIcon: darkTeamChallenges,
              //   access: true,
              //   show: true
              // }
            ]
          },
          {
            name: LeftSidebarData.featuresAndToolsParentMenu.featuresAndTools,
            dropDownHref: 'isDropDown',
            navIcon: 'tools',
            access: true,
            isDropDown: true,
            subMenu: [
              {
                name: LeftSidebarData.featuresAndToolsParentMenu.pulseSurveys,
                href: `/${userData?.slug}/pulse-survey`,
                navIcon: 'pulseSurvey',
                access: true,
                show: true
              },

              {
                name: 'Challenges',
                href: `/${userData?.slug}/challenges`,
                navIcon: 'challenges',
                access: true,
                show: true
              },
              {
                name: 'Perks',
                href: `/${userData?.slug}/offering`,
                navIcon: 'perks',
                access: true,
                show: !isB2BFansMode
              },

              {
                name: LeftSidebarData.featuresAndToolsParentMenu.solutions,
                href: `/${userData?.slug}/solution`,
                navIcon: 'solutions',
                access: true,
                remove: subsData?.account !== 'Expired' ? false : true,
                show: true
              },
              {
                name: LeftSidebarData.featuresAndToolsParentMenu.pushNotifications,
                href: `/${userData?.slug}/push-notification`,
                navIcon: 'notifications',
                access: true,
                remove: subsData?.account !== 'Expired' ? false : true,
                show: true
              },
              {
                name: 'Marketplace',
                href: `/${userData?.slug}/marketplace`,
                navIcon: 'marketplace',
                access: true,
                show: true
              },
              {
                name: 'Shoutouts',
                href: `/${userData?.slug}/shoutouts`,
                navIcon: 'shoutouts',
                access: true,
                show: true
              }
            ]
          }
        ]);
      } else if (userData?.userType === 5) {
        setSidebarData([
          {
            name: LeftSidebarData.adminParentMenu.dashboard,
            href: `/partner-dashboard`,
            navIcon: 'dashboard',
            access: true
          },
          {
            name: LeftSidebarData.adminParentMenu.admin,
            href: `/${userData?.slug}/dashboard`,
            dropDownHref: 'isDropDown',
            navIcon: 'admin',
            access: true,
            isDropDown: true,
            subMenu: [
              {
                name: LeftSidebarData.featuresAndToolsParentMenu.earnings,
                href: `/partner-earning`,
                navIcon: 'earnings',
                access: true,
                show: true
              }
            ]
          },
          {
            name: LeftSidebarData.peopleManagementParentMenu.peopleManagement,
            dropDownHref: 'isDropDown',
            navIcon: 'people',
            access: true,
            isDropDown: true,
            subMenu: [
              {
                name: LeftSidebarData.peopleManagementParentMenu.myAccount,
                href: `/partner-account`,
                navIcon: 'account',
                access: true,
                show: true
              },
              {
                name: LeftSidebarData.peopleManagementParentMenu.introduceCompanies,
                href: `/introduce`,
                navIcon: 'introduce',
                access: true,
                show: true
              }
            ]
          },
          {
            name: LeftSidebarData.featuresAndToolsParentMenu.featuresAndTools,
            dropDownHref: 'isDropDown',
            navIcon: 'tools',
            access: true,
            isDropDown: true,
            subMenu: [
              {
                name: LeftSidebarData.featuresAndToolsParentMenu.notifications,
                href: `/partner-notification`,
                navIcon: 'notifications',
                access: true,
                show: true
              },
              {
                name: LeftSidebarData.featuresAndToolsParentMenu.legals,
                href: `/partner-legals`,
                navIcon: 'legals',
                access: true,
                show: true
              },
              {
                name: LeftSidebarData.featuresAndToolsParentMenu.assets,
                href: `/partner-assets`,
                navIcon: 'assets',
                access: true,
                show: true
              }
              // {
              //   name: LeftSidebarData.featuresAndToolsParentMenu.healthVideos,
              //   href: '/health-videos',
              //   icon: guidance,
              //   activeIcon: guidanceActive,
              //   darkIcon: guidanceDark,
              //   access: true,
              //   show: true
              // }
            ]
          }
        ]);
      } else if (userData?.userType === 6) {
        setSidebarData([
          {
            name: LeftSidebarData.adminParentMenu.dashboard,
            href: `/  -dashboard`,
            navIcon: 'dashboard',
            access: true,
            isDisabled: userData?.expertApprove === 'false'
          },
          {
            name: LeftSidebarData.schedule,
            href: `/#`,
            navIcon: 'schedule',
            access: true,
            isDisabled: userData?.expertApprove === 'false'
          },
          {
            name: LeftSidebarData.clients,
            href: `/expert-clients/my-client`,
            navIcon: 'clients',
            access: true,
            isDisabled: userData?.expertApprove === 'false'
          },
          {
            name: LeftSidebarData.featuresAndToolsParentMenu.notifications,
            href: `/#`,
            navIcon: 'notifications',
            access: true,
            isDisabled: userData?.expertApprove === 'false'
          },
          {
            name: LeftSidebarData.me,
            href: `/expert-me`,
            navIcon: 'account',
            access: true
          },
          {
            name: LeftSidebarData.payments,
            href: `/#`,
            navIcon: 'payments',
            access: true,
            isDisabled: userData?.expertApprove === 'false'
          }
        ]);
      } else if (userData?.userType === 1) {
        //shoorah sub admin
        setSidebarData([
          {
            name: LeftSidebarData.adminParentMenu.dashboard,
            href: '/dashboard',
            navIcon: 'dashboard',
            access: true
          },
          {
            name: LeftSidebarData.adminParentMenu.admin,
            href: '/dashboard',
            dropDownHref: 'isDropDown',
            navIcon: 'admin',
            access: true,
            isDropDown: true,
            subMenu: [
              {
                // Shoorah-internal PDFs — platform-wide or about one company.
                name: 'Reports',
                href: '/reports',
                navIcon: 'report',
                access: true,
                show: true
              },
              {
                name: LeftSidebarData.adminParentMenu.cms,
                href: '/cms',
                navIcon: 'cms',
                access: true,
                show: true
              },
              {
                name: LeftSidebarData.adminParentMenu.config,
                href: '/config',
                navIcon: 'config',
                access: true,
                show: true
              }
            ]
          },
          {
            name: LeftSidebarData.peopleManagementParentMenu.peopleManagement,
            dropDownHref: 'isDropDown',
            navIcon: 'people',
            access: true,
            isDropDown: true,
            subMenu: [
              {
                name: LeftSidebarData.peopleManagementParentMenu.users,
                href: '/users',
                navIcon: 'users',
                access: true,
                show: true
              },
              {
                name: LeftSidebarData.peopleManagementParentMenu.ourExperts,
                href: `/podExperts`,
                navIcon: 'experts',
                access: true,
                show: true
              }
            ]
          },
          {
            name: LeftSidebarData.eliteGamesParentMenu.eliteGames,
            dropDownHref: 'isDropDown',
            navIcon: 'games',
            access: true,
            isDropDown: true,
            subMenu: [
              {
                name: LeftSidebarData.eliteGamesParentMenu.quizZone,
                href: '/game/quizZone/main-category',
                matchHrefs: ['/game/quizZone'],
                navIcon: 'quiz',
                access: true,
                show: true
              },
              {
                name: LeftSidebarData.eliteGamesParentMenu.dailyQuiz,
                href: '/game/daily-quiz/manage-questions',
                matchHrefs: ['/game/daily-quiz'],
                navIcon: 'dailyQuiz',
                access: true,
                show: true
              },
              {
                name: LeftSidebarData.eliteGamesParentMenu.multiMatch,
                href: '/game/multi-match/mainCategory',
                matchHrefs: ['/game/multi-match'],
                navIcon: 'match',
                access: true,
                show: true
              },
              {
                name: LeftSidebarData.eliteGamesParentMenu.funNLearn,
                href: '/game/fun-n-learn/maincategory',
                matchHrefs: ['/game/fun-n-learn'],
                navIcon: 'learn',
                access: true,
                show: true
              },
              {
                name: LeftSidebarData.eliteGamesParentMenu.guessTheWord,
                href: '/game/guess-the-word-category',
                matchHrefs: ['/game/guess-the-word', '/game/guess-the-word-category'],
                navIcon: 'word',
                access: true,
                show: true
              },
              {
                name: LeftSidebarData.eliteGamesParentMenu.mathsQuiz,
                href: '/game/maths-quiz-category',
                matchHrefs: [
                  '/game/maths-quiz',
                  '/game/maths-quiz-category',
                  '/game/maths-quiz-subcategory'
                ],
                navIcon: 'maths',
                access: true,
                show: true
              },
              {
                name: LeftSidebarData.eliteGamesParentMenu.leaderboard,
                href: '/game/leaderboard/all',
                matchHrefs: ['/game/leaderboard'],
                navIcon: 'leaderboard',
                access: true,
                show: true
              }
            ]
          },
          {
            name: LeftSidebarData.featuresAndToolsParentMenu.featuresAndTools,
            dropDownHref: 'isDropDown',
            navIcon: 'tools',
            access: true,
            isDropDown: true,
            subMenu: [
              {
                name: LeftSidebarData.featuresAndToolsParentMenu.peapDashboard,
                href: '/peap-dashboard',
                navIcon: 'peap',
                access: true,
                show: true
              },
              {
                name: LeftSidebarData.featuresAndToolsParentMenu.b2bWellPoints,
                href: '/peap-B2B-wellPoints',
                navIcon: 'wellpoints',
                access: true,
                show: false
              },
              {
                name: LeftSidebarData.featuresAndToolsParentMenu.specialistManager,
                href: '/peap-management',
                navIcon: 'specialist',
                access: true,
                show: false
              },
              {
                name: LeftSidebarData.featuresAndToolsParentMenu.pulseSurvey,
                href: `/pulse-survey`,
                navIcon: 'pulseSurvey',
                access: true,
                show: true
              },
              {
                name: LeftSidebarData.featuresAndToolsParentMenu.tutorials,
                href: '/tutorials',
                navIcon: 'tutorials',
                access: true,
                show: true
              },
              {
                name: LeftSidebarData.featuresAndToolsParentMenu.pushNotifications,
                href: '/push-notification',
                navIcon: 'notifications',
                access: true,
                show: true
              },
              {
                name: 'Challenges',
                href: '/challenges',
                navIcon: 'challenges',
                access: true,
                show: true
              },
              {
                name: 'Offerings',
                href: '/offering',
                navIcon: 'benefits',
                access: true,
                show: true
              },
              {
                name: LeftSidebarData.featuresAndToolsParentMenu.earnings,
                href: '/earning',
                navIcon: 'earnings',
                access: userData?.moduleAccess?.earning_module_access,
                show: true
              },
              {
                name: LeftSidebarData.featuresAndToolsParentMenu.appIssues,
                href: '/app-issues',
                navIcon: 'issues',
                access: !userData?.userType,
                show: true
              },
              {
                name: LeftSidebarData.featuresAndToolsParentMenu.appFeedback,
                href: '/app-feedbacks',
                navIcon: 'feedback',
                access: true,
                show: true
              }
              // {
              //   name: LeftSidebarData.featuresAndToolsParentMenu.healthVideos,
              //   href: '/health-videos',
              //   icon: guidance,
              //   activeIcon: guidanceActive,
              //   darkIcon: guidanceDark,
              //   access: true,
              //   show: true
              // }
            ]
          },
          {
            name: LeftSidebarData.experienceParentMenu.experience,
            dropDownHref: 'isDropDown',
            navIcon: 'experience',
            access: true,
            isDropDown: true,
            subMenu: [
              {
                name: LeftSidebarData.experienceParentMenu.focuses,
                href: '/focus',
                navIcon: 'focus',
                access: true,
                show: true
              },
              {
                name: LeftSidebarData.experienceParentMenu.focus,
                href: '/focus/add-edit',
                navIcon: 'focus',
                access: true,
                show: false
              },
              {
                name: LeftSidebarData.experienceParentMenu.focus,
                href: '/focus/view',
                navIcon: 'focus',
                access: true,
                show: false
              },
              {
                name: LeftSidebarData.experienceParentMenu.affirmation,
                href: '/affirmation',
                navIcon: 'affirmation',
                access: true,
                show: true
              },
              {
                name: LeftSidebarData.experienceParentMenu.affirmation,
                href: '/affirmation/add-edit',
                navIcon: 'affirmation',
                access: true,
                show: false
              },
              {
                name: LeftSidebarData.experienceParentMenu.affirmation,
                href: '/affirmation/view',
                navIcon: 'affirmation',
                access: true,
                show: false
              },
              {
                name: LeftSidebarData.experienceParentMenu.meditation,
                href: '/meditation/manage',
                navIcon: 'meditation',
                access: true,
                show: false
              },
              {
                name: LeftSidebarData.experienceParentMenu.meditation,
                href: '/meditation/manage/add-edit',
                navIcon: 'meditation',
                access: true,
                show: false
              },
              {
                // "Meditation" analytics section: /meditation prefix covers all
                // its sub-pages for active-state matching (the sidebar matches
                // via includes()). Distinct from /meditation/manage
                // above, which is the library rather than the reporting on it.
                name: LeftSidebarData.experienceParentMenu.meditation,
                href: '/meditation',
                navIcon: 'meditation',
                access: true,
                show: true
              },
              {
                // "Sleep" section: /sleep prefix covers all its sub-pages for
                // active-state matching (the sidebar matches via includes()).
                name: LeftSidebarData.experienceParentMenu.sleepSounds,
                href: '/sleep',
                navIcon: 'sleep',
                access: true,
                show: true
              },
              {
                name: LeftSidebarData.experienceParentMenu.sleepSounds,
                href: '/sleep/manage',
                navIcon: 'sleep',
                access: true,
                show: false
              },
              {
                name: LeftSidebarData.experienceParentMenu.sleepSounds,
                href: '/sleep/manage/add-edit',
                navIcon: 'sleep',
                access: true,
                show: false
              },
              {
                // "Shoorah Pods" section (dashboards + logs). The pod library
                // is in this hub's "Manage content" dropdown.
                name: LeftSidebarData.experienceParentMenu.shoorahPods,
                href: '/shoorah-pods',
                navIcon: 'pods',
                access: true,
                show: true
              },
              {
                name: 'Shuru',
                href: '/shuru',
                navIcon: 'shuru',
                access: true,
                show: true
              },
              {
                name: 'Mood Tracking',
                href: '/mood',
                navIcon: 'mood',
                access: true,
                show: true
              },
              {
                name: 'Scans',
                href: '/scans',
                navIcon: 'scans',
                access: true,
                show: true
              },
              {
                name: 'Games',
                href: '/games',
                navIcon: 'games',
                access: true,
                show: true
              },
              {
                name: 'Guided Path',
                href: '/guided-path',
                navIcon: 'guidedPath',
                access: true,
                show: true
              },
              {
                name: 'Trigger Trace',
                href: '/trigger-trace',
                navIcon: 'triggerTrace',
                access: true,
                show: true
              },
              {
                name: 'Home Testing',
                href: '/home-testing',
                navIcon: 'homeTesting',
                access: true,
                show: true
              },
              {
                name: 'Elite Mind',
                href: '/elite-mind',
                navIcon: 'eliteMind',
                access: true,
                show: true
              },
              {
                name: 'MoneyMind',
                href: '/moneymind',
                navIcon: 'moneyMind',
                access: true,
                show: true
              },
              {
                name: 'Self Development',
                href: '/self-development',
                navIcon: 'selfDevelopment',
                access: true,
                show: true
              },
              {
                name: 'Cessation',
                href: '/cessation',
                navIcon: 'cessation',
                access: true,
                show: true
              },
              {
                name: 'Marketplace',
                href: '/marketplace-insights',
                navIcon: 'marketplace',
                access: true,
                show: true
              },
              {
                name: 'Perks',
                href: '/perks',
                navIcon: 'perks',
                access: true,
                show: true
              },
              {
                name: 'Challenges',
                href: '/challenges-insights',
                navIcon: 'challenges',
                access: true,
                show: true
              },
              {
                name: LeftSidebarData.experienceParentMenu.shoorahPods,
                href: '/shoorah-pods/manage',
                navIcon: 'pods',
                access: true,
                show: false
              },
              {
                name: LeftSidebarData.experienceParentMenu.shoorahPods,
                href: '/shoorah-pods/manage/add-edit',
                navIcon: 'pods',
                access: true,
                show: false
              },
              {
                // "Habits" section (tracker dashboards + logs); content CRUD
                // stays at /habit-tracker/manage, reachable from the
                // dashboard's "Manage habits" button. includes() matching
                // keeps this highlighted on the content pages too.
                name: LeftSidebarData.experienceParentMenu.rituals,
                href: '/habit-tracker',
                navIcon: 'habits',
                access: true,
                show: true
              },
              {
                name: LeftSidebarData.experienceParentMenu.rituals,
                href: '/habit-tracker/manage',
                navIcon: 'habits',
                access: true,
                show: false
              },
              {
                name: LeftSidebarData.experienceParentMenu.rituals,
                href: '/habit-tracker/manage/add-edit',
                navIcon: 'habits',
                access: true,
                show: false
              },
              {
                name: LeftSidebarData.experienceParentMenu.topPicks,
                href: '/top-picks',
                navIcon: 'topPicks',
                access: true,
                show: false
              },
              {
                name: LeftSidebarData.experienceParentMenu.topPicks,
                href: '/top-picks/add-edit',
                navIcon: 'topPicks',
                access: true,
                show: false
              },
              {
                // "Vision Board" section (dashboards + logs). The idea
                // catalogue stays at /vision-board/manage, in the hub's
                // "Manage content" dropdown.
                name: 'Vision Board',
                href: '/vision-board',
                navIcon: 'visionBoard',
                access: true,
                show: true
              },
              {
                name: LeftSidebarData.experienceParentMenu.visionBoardIdeas,
                href: '/vision-board/manage',
                navIcon: 'visionBoard',
                access: true,
                show: true
              },
              {
                name: LeftSidebarData.experienceParentMenu.visionBoardIdeas,
                href: '/vision-board/manage/add-edit',
                navIcon: 'visionBoard',
                access: true,
                show: false
              },
              {
                // "Breathwork" section (dashboards + logs); content CRUD stays
                // at /breathwork/manage, reachable from the Audio
                // dashboard's "Manage Breathworks" button. includes() matching
                // keeps this highlighted on the content pages too.
                name: LeftSidebarData.experienceParentMenu.breathWork,
                href: '/breathwork',
                navIcon: 'breathwork',
                access: true,
                show: true
              },
              {
                // "Shoorah Vids" section (dashboards + logs). The video
                // library itself stays at /guidance and is reachable from the
                // hub's "Manage content" dropdown.
                name: LeftSidebarData.experienceParentMenu.shoorahVids,
                href: '/shoorah-vids',
                navIcon: 'vids',
                access: true,
                show: true
              },
              {
                name: LeftSidebarData.experienceParentMenu.shoorahVids,
                href: '/guidance',
                navIcon: 'vids',
                access: true,
                show: false
              },
              {
                // Reporting on the answers. The assessment builder is in
                // this hub's "Manage content" dropdown, under
                // /self-assessment/manage.
                name: LeftSidebarData.experienceParentMenu.selfAssessment,
                href: '/self-assessment',
                navIcon: 'selfAssessment',
                access: true,
                show: true
              }
            ]
          },
          {
            name: LeftSidebarData.businessHubParentMenu.businessHub,
            dropDownHref: 'isDropDown',
            navIcon: 'business',
            access: true,
            isDropDown: true,
            subMenu: [
              {
                name: LeftSidebarData.businessHubParentMenu.b2b,
                href: '/B2B-dashboard',
                navIcon: 'company',
                access: true,
                show: true
              },
              {
                name: LeftSidebarData.businessHubParentMenu.b2bCompanyList,
                href: '/B2B-company-list',
                navIcon: 'company',
                access: true,
                show: false
              },
              {
                name: LeftSidebarData.businessHubParentMenu.b2bEarnings,
                href: '/B2B-earning',
                navIcon: 'earnings',
                access: true,
                show: false
              },
              {
                name: LeftSidebarData.businessHubParentMenu.partners,
                href: '/partners',
                navIcon: 'partners',
                access: true,
                show: true
              },
              {
                name: LeftSidebarData.businessHubParentMenu.partnerIntroduced,
                href: '/partner-introduced',
                navIcon: 'introduce',
                access: true,
                show: false
              }
            ]
          },
          {
            name: LeftSidebarData.schoolManagementParentMenu.schoolManagement,
            dropDownHref: 'isDropDown',
            navIcon: 'school',
            access: true,
            isDropDown: true,
            subMenu: [
              {
                name: LeftSidebarData.schoolManagementParentMenu.overview,
                href: '/school-dashboard',
                navIcon: 'dashboard',
                access: true,
                show: true
              },
              {
                // Also lights up on /school-management/create and /:id.
                name: LeftSidebarData.schoolManagementParentMenu.manageSchools,
                href: '/school-management',
                navIcon: 'school',
                access: true,
                show: true
              }
            ]
          },
          {
            name: LeftSidebarData.kidsManagementParentMenu.kidsManagement,
            dropDownHref: 'isDropDown',
            navIcon: 'kids',
            access: true,
            isDropDown: true,
            subMenu: [
              {
                name: LeftSidebarData.kidsManagementParentMenu.kidsDashboard,
                href: `/kids-dashboard`,
                navIcon: 'dashboard',
                access: true,
                show: true
              },
              {
                name: LeftSidebarData.kidsManagementParentMenu.kids,
                href: '/kids-list',
                navIcon: 'kids',
                access: true,
                show: true
              },

              {
                name: LeftSidebarData.kidsManagementParentMenu.kidsPods,
                href: '/kids-content-management/kids-pods',
                navIcon: 'pods',
                access: true,
                show: true
              },
              {
                name: LeftSidebarData.kidsManagementParentMenu.affirmation,
                href: '/kids-content-management/affirmation',
                navIcon: 'affirmation',
                access: true,
                show: true
              },
              {
                name: LeftSidebarData.kidsManagementParentMenu.stories,
                href: '/kids-content-management/stories',
                navIcon: 'sleep',
                access: true,
                show: true
              }
            ]
          }
          // {
          //   name: LeftSidebarData.shoorahHealth.shoorahHealth,
          //   href: `/health/health-dashboard`,
          //   icon: userIcon,
          //   activeIcon: activeuserIcon,
          //   darkIcon: darkuserIcon,
          //   access: true,
          //   show: true
          // }
        ]);
      } else {
        // Shoorah super Admin
        setSidebarData([
          {
            name: LeftSidebarData.adminParentMenu.dashboard,
            href: '/dashboard',
            navIcon: 'dashboard',
            access: true
          },
          {
            name: LeftSidebarData.adminParentMenu.admin,
            dropDownHref: 'isDropDown',
            navIcon: 'admin',
            access: true,
            isDropDown: true,
            subMenu: [
              {
                // Shoorah-internal PDFs — platform-wide or about one company.
                name: 'Reports',
                href: '/reports',
                navIcon: 'report',
                access: true,
                show: true
              },
              {
                name: LeftSidebarData.adminParentMenu.contentApproval,
                href: '/content-approval',
                navIcon: 'approval',
                access: !userData?.userType,
                show: true
              },
              {
                name: LeftSidebarData.adminParentMenu.cms,
                href: '/cms',
                navIcon: 'cms',
                access: true,
                show: true
              },
              {
                name: LeftSidebarData.adminParentMenu.config,
                href: '/config',
                navIcon: 'config',
                access: true,
                show: true
              }
            ]
          },
          {
            name: LeftSidebarData.peopleManagementParentMenu.peopleManagement,
            dropDownHref: 'isDropDown',
            navIcon: 'people',
            access: true,
            isDropDown: true,
            subMenu: [
              {
                name: LeftSidebarData.peopleManagementParentMenu.users,
                href: '/users',
                navIcon: 'users',
                access: true,
                show: true
              },
              {
                name: LeftSidebarData.peopleManagementParentMenu.ourExperts,
                href: `/podExperts`,
                navIcon: 'experts',
                access: true,
                show: true
              },
              {
                name: LeftSidebarData.peopleManagementParentMenu.adminShoorahStaff,
                href: '/sub-admins',
                navIcon: 'staff',
                access: !userData?.userType,
                show: true
              },
              {
                name: 'Peap Management',
                href: '/peap-dashboard',
                navIcon: 'peap',
                access: true,
                show: true
              },
              {
                name: LeftSidebarData.featuresAndToolsParentMenu.b2bWellPoints,
                href: '/peap-B2B-wellPoints',
                navIcon: 'wellpoints',
                access: true,
                show: false
              },
              {
                name: LeftSidebarData.featuresAndToolsParentMenu.specialistManager,
                href: '/peap-management',
                navIcon: 'specialist',
                access: true,
                show: false
              }
            ]
          },
          // {
          //   name: LeftSidebarData.featuresAndToolsParentMenu.featuresAndTools,
          //   dropDownHref: 'isDropDown',
          //   icon: Features,
          //   activeIcon: Features,
          //   darkIcon: Features,
          //   access: true,
          //   isDropDown: true,
          //   subMenu: [
          //     {
          //       name: LeftSidebarData.featuresAndToolsParentMenu.pulseSurvey,
          //       href: `/pulse-survey`,
          //       icon: approvalIcon,
          //       activeIcon: activeapprovalIcon,
          //       darkIcon: darkapprovalIcon,
          //       access: true,
          //       show: true
          //     }
          //   ]
          // },
          {
            name: LeftSidebarData.featuresAndToolsParentMenu.featuresAndTools,
            dropDownHref: 'isDropDown',
            navIcon: 'tools',
            access: true,
            isDropDown: true,
            subMenu: [
              {
                name: LeftSidebarData.featuresAndToolsParentMenu.pulseSurvey,
                href: `/pulse-survey`,
                navIcon: 'pulseSurvey',
                access: true,
                show: true
              },

              {
                name: 'Badges',
                href: '/badges',
                navIcon: 'badges',
                access: true,
                show: true
              },
              {
                name: 'Challenges',
                href: '/challenges',
                navIcon: 'challenges',
                access: true,
                show: true
              },
              // {
              //   name: 'Tasks',
              //   href: '/tasks',
              //   icon: B2BWellPoints,
              //   activeIcon: activeb2bwellpointsIcon,
              //   darkIcon: activeB2bWellpoints,
              //   access: true,
              //   show: true
              // },
              {
                name: 'Offerings',
                href: '/offering',
                navIcon: 'benefits',
                access: true,
                show: true
              },
              {
                name: LeftSidebarData.featuresAndToolsParentMenu.shoorahTest,
                href: '/test/tests-dashboard',
                navIcon: 'shoorahTest',
                access: true,
                show: true
              },
              {
                name: LeftSidebarData.featuresAndToolsParentMenu.shoorahTestForB2CUsers,
                href: '/test/b2c',
                navIcon: 'shoorahTest',
                access: true,
                show: false
              },
              {
                name: LeftSidebarData.featuresAndToolsParentMenu.shoorahTestForB2BUsers,
                href: '/test/b2b',
                navIcon: 'shoorahTest',
                access: true,
                show: false
              },
              {
                name: LeftSidebarData.featuresAndToolsParentMenu.tutorials,
                href: '/tutorials',
                navIcon: 'tutorials',
                access: true,
                show: true
              },
              {
                name: LeftSidebarData.featuresAndToolsParentMenu.pushNotifications,
                href: '/push-notification',
                navIcon: 'notifications',
                access: true,
                show: true
              },
              {
                name: LeftSidebarData.featuresAndToolsParentMenu.earnings,
                href: '/earning',
                navIcon: 'earnings',
                access: userData?.moduleAccess?.earning_module_access
              },
              {
                name: LeftSidebarData.featuresAndToolsParentMenu.appIssues,
                href: '/app-issues',
                navIcon: 'issues',
                access: !userData?.userType,
                show: true
              },
              {
                name: LeftSidebarData.featuresAndToolsParentMenu.appFeedback,
                href: '/app-feedbacks',
                navIcon: 'feedback',
                access: true,
                show: true
              }
              // {
              //   name: LeftSidebarData.featuresAndToolsParentMenu.benefits,
              //   href: `/benefits`,
              //   icon: guidance,
              //   activeIcon: guidanceActive,
              //   darkIcon: guidanceDark,
              //   access: true,
              //   show: true
              // }
              // {
              //   name: LeftSidebarData.featuresAndToolsParentMenu.benefits,
              //   href: `/benefits`,
              //   icon: guidance,
              //   activeIcon: guidanceActive,
              //   darkIcon: guidanceDark,
              //   access: true,
              //   show: true
              // }
              // {
              //   name: LeftSidebarData.featuresAndToolsParentMenu.healthVideos,
              //   href: '/health-videos',
              //   icon: guidance,
              //   activeIcon: guidanceActive,
              //   darkIcon: guidanceDark,
              //   access: true,
              //   show: true
              // }
            ]
          },
          {
            name: LeftSidebarData.eliteGamesParentMenu.eliteGames,
            dropDownHref: 'isDropDown',
            navIcon: 'games',
            access: true,
            isDropDown: true,
            subMenu: [
              {
                name: LeftSidebarData.eliteGamesParentMenu.quizZone,
                href: '/game/quizZone/main-category',
                matchHrefs: ['/game/quizZone'],
                navIcon: 'quiz',
                access: true,
                show: true
              },
              {
                name: LeftSidebarData.eliteGamesParentMenu.dailyQuiz,
                href: '/game/daily-quiz/manage-questions',
                matchHrefs: ['/game/daily-quiz'],
                navIcon: 'dailyQuiz',
                access: true,
                show: true
              },
              {
                name: LeftSidebarData.eliteGamesParentMenu.multiMatch,
                href: '/game/multi-match/mainCategory',
                matchHrefs: ['/game/multi-match'],
                navIcon: 'match',
                access: true,
                show: true
              },
              {
                name: LeftSidebarData.eliteGamesParentMenu.funNLearn,
                href: '/game/fun-n-learn/maincategory',
                matchHrefs: ['/game/fun-n-learn'],
                navIcon: 'learn',
                access: true,
                show: true
              },
              {
                name: LeftSidebarData.eliteGamesParentMenu.guessTheWord,
                href: '/game/guess-the-word-category',
                matchHrefs: ['/game/guess-the-word', '/game/guess-the-word-category'],
                navIcon: 'word',
                access: true,
                show: true
              },
              {
                name: LeftSidebarData.eliteGamesParentMenu.mathsQuiz,
                href: '/game/maths-quiz-category',
                matchHrefs: [
                  '/game/maths-quiz',
                  '/game/maths-quiz-category',
                  '/game/maths-quiz-subcategory'
                ],
                navIcon: 'maths',
                access: true,
                show: true
              },
              {
                name: LeftSidebarData.eliteGamesParentMenu.leaderboard,
                href: '/game/leaderboard/all',
                matchHrefs: ['/game/leaderboard'],
                navIcon: 'leaderboard',
                access: true,
                show: true
              }
            ]
          },
          {
            name: LeftSidebarData.experienceParentMenu.experience,
            dropDownHref: 'isDropDown',
            navIcon: 'experience',
            access: true,
            isDropDown: true,
            subMenu: [
              {
                name: LeftSidebarData.experienceParentMenu.focuses,
                href: '/focus',
                navIcon: 'focus',
                access: true,
                show: true
              },
              {
                name: LeftSidebarData.experienceParentMenu.focus,
                href: '/focus/add-edit',
                navIcon: 'focus',
                access: true,
                show: false
              },
              {
                name: LeftSidebarData.experienceParentMenu.focus,
                href: '/focus/view',
                navIcon: 'focus',
                access: true,
                show: false
              },
              {
                name: LeftSidebarData.experienceParentMenu.affirmation,
                href: '/affirmation',
                navIcon: 'affirmation',
                access: true,
                show: true
              },
              {
                name: LeftSidebarData.experienceParentMenu.affirmation,
                href: '/affirmation/add-edit',
                navIcon: 'affirmation',
                access: true,
                show: false
              },
              {
                name: LeftSidebarData.experienceParentMenu.affirmation,
                href: '/affirmation/view',
                navIcon: 'affirmation',
                access: true,
                show: false
              },
              {
                name: LeftSidebarData.experienceParentMenu.meditation,
                href: '/meditation/manage',
                navIcon: 'meditation',
                access: true,
                show: false
              },
              {
                name: LeftSidebarData.experienceParentMenu.meditation,
                href: '/meditation/manage/add-edit',
                navIcon: 'meditation',
                access: true,
                show: false
              },
              {
                // "Meditation" analytics section: /meditation prefix covers all
                // its sub-pages for active-state matching (the sidebar matches
                // via includes()). Distinct from /meditation/manage
                // above, which is the library rather than the reporting on it.
                name: LeftSidebarData.experienceParentMenu.meditation,
                href: '/meditation',
                navIcon: 'meditation',
                access: true,
                show: true
              },
              {
                // "Sleep" section: /sleep prefix covers all its sub-pages for
                // active-state matching (the sidebar matches via includes()).
                name: LeftSidebarData.experienceParentMenu.sleepSounds,
                href: '/sleep',
                navIcon: 'sleep',
                access: true,
                show: true
              },
              {
                name: LeftSidebarData.experienceParentMenu.sleepSounds,
                href: '/sleep/manage',
                navIcon: 'sleep',
                access: true,
                show: false
              },
              {
                name: LeftSidebarData.experienceParentMenu.sleepSounds,
                href: '/sleep/manage/add-edit',
                navIcon: 'sleep',
                access: true,
                show: false
              },
              {
                // "Shoorah Pods" section (dashboards + logs). The pod library
                // is in this hub's "Manage content" dropdown.
                name: LeftSidebarData.experienceParentMenu.shoorahPods,
                href: '/shoorah-pods',
                navIcon: 'pods',
                access: true,
                show: true
              },
              {
                name: 'Shuru',
                href: '/shuru',
                navIcon: 'shuru',
                access: true,
                show: true
              },
              {
                name: 'Mood Tracking',
                href: '/mood',
                navIcon: 'mood',
                access: true,
                show: true
              },
              {
                name: 'Scans',
                href: '/scans',
                navIcon: 'scans',
                access: true,
                show: true
              },
              {
                name: 'Games',
                href: '/games',
                navIcon: 'games',
                access: true,
                show: true
              },
              {
                name: 'Guided Path',
                href: '/guided-path',
                navIcon: 'guidedPath',
                access: true,
                show: true
              },
              {
                name: 'Trigger Trace',
                href: '/trigger-trace',
                navIcon: 'triggerTrace',
                access: true,
                show: true
              },
              {
                name: 'Home Testing',
                href: '/home-testing',
                navIcon: 'homeTesting',
                access: true,
                show: true
              },
              {
                name: 'Elite Mind',
                href: '/elite-mind',
                navIcon: 'eliteMind',
                access: true,
                show: true
              },
              {
                name: 'MoneyMind',
                href: '/moneymind',
                navIcon: 'moneyMind',
                access: true,
                show: true
              },
              {
                name: 'Self Development',
                href: '/self-development',
                navIcon: 'selfDevelopment',
                access: true,
                show: true
              },
              {
                name: 'Cessation',
                href: '/cessation',
                navIcon: 'cessation',
                access: true,
                show: true
              },
              {
                name: 'Marketplace',
                href: '/marketplace-insights',
                navIcon: 'marketplace',
                access: true,
                show: true
              },
              {
                name: 'Perks',
                href: '/perks',
                navIcon: 'perks',
                access: true,
                show: true
              },
              {
                name: 'Challenges',
                href: '/challenges-insights',
                navIcon: 'challenges',
                access: true,
                show: true
              },
              {
                name: LeftSidebarData.experienceParentMenu.shoorahPods,
                href: '/shoorah-pods/manage',
                navIcon: 'pods',
                access: true,
                show: false
              },
              {
                name: LeftSidebarData.experienceParentMenu.shoorahPods,
                href: '/shoorah-pods/manage/add-edit',
                navIcon: 'pods',
                access: true,
                show: false
              },
              {
                // "Habits" section (tracker dashboards + logs); content CRUD
                // stays at /habit-tracker/manage, reachable from the
                // dashboard's "Manage habits" button. includes() matching
                // keeps this highlighted on the content pages too.
                name: LeftSidebarData.experienceParentMenu.rituals,
                href: '/habit-tracker',
                navIcon: 'habits',
                access: true,
                show: true
              },
              {
                name: LeftSidebarData.experienceParentMenu.rituals,
                href: '/habit-tracker/manage',
                navIcon: 'habits',
                access: true,
                show: false
              },
              {
                name: LeftSidebarData.experienceParentMenu.rituals,
                href: '/habit-tracker/manage/add-edit',
                navIcon: 'habits',
                access: true,
                show: false
              },
              {
                name: LeftSidebarData.experienceParentMenu.topPicks,
                href: '/top-picks',
                navIcon: 'topPicks',
                access: true,
                show: false
              },
              {
                name: LeftSidebarData.experienceParentMenu.topPicks,
                href: '/top-picks/add-edit',
                navIcon: 'topPicks',
                access: true,
                show: false
              },
              {
                // "Vision Board" section (dashboards + logs). The idea
                // catalogue stays at /vision-board/manage, in the hub's
                // "Manage content" dropdown.
                name: 'Vision Board',
                href: '/vision-board',
                navIcon: 'visionBoard',
                access: true,
                show: true
              },
              {
                name: LeftSidebarData.experienceParentMenu.visionBoardIdeas,
                href: '/vision-board/manage',
                navIcon: 'visionBoard',
                access: true,
                show: true
              },
              {
                name: LeftSidebarData.experienceParentMenu.visionBoardIdeas,
                href: '/vision-board/manage/add-edit',
                navIcon: 'visionBoard',
                access: true,
                show: false
              },
              {
                // "Breathwork" section (dashboards + logs); content CRUD stays
                // at /breathwork/manage, reachable from the Audio
                // dashboard's "Manage Breathworks" button. includes() matching
                // keeps this highlighted on the content pages too.
                name: LeftSidebarData.experienceParentMenu.breathWork,
                href: '/breathwork',
                navIcon: 'breathwork',
                access: true,
                show: true
              },
              {
                // "Shoorah Vids" section (dashboards + logs). The video
                // library itself stays at /guidance and is reachable from the
                // hub's "Manage content" dropdown.
                name: LeftSidebarData.experienceParentMenu.shoorahVids,
                href: '/shoorah-vids',
                navIcon: 'vids',
                access: true,
                show: true
              },
              {
                name: LeftSidebarData.experienceParentMenu.shoorahVids,
                href: '/guidance',
                navIcon: 'vids',
                access: true,
                show: false
              },
              {
                name: LeftSidebarData.experienceParentMenu.marketplace,
                href: `/marketplace`,
                navIcon: 'marketplace',
                access: true,
                show: true
              },
              {
                // Reporting on the answers. The assessment builder is in
                // this hub's "Manage content" dropdown, under
                // /self-assessment/manage.
                name: LeftSidebarData.experienceParentMenu.selfAssessment,
                href: '/self-assessment',
                navIcon: 'selfAssessment',
                access: true,
                show: true
              }
            ]
          },
          {
            name: LeftSidebarData.businessHubParentMenu.businessHub,
            dropDownHref: 'isDropDown',
            navIcon: 'business',
            access: true,
            isDropDown: true,
            subMenu: [
              {
                name: LeftSidebarData.businessHubParentMenu.b2b,
                href: '/B2B-dashboard',
                navIcon: 'company',
                access: true,
                show: true
              },
              {
                name: LeftSidebarData.businessHubParentMenu.b2bCompanyList,
                href: '/B2B-company-list',
                navIcon: 'company',
                access: true,
                show: false
              },
              {
                name: LeftSidebarData.businessHubParentMenu.b2bEarnings,
                href: '/B2B-earning',
                navIcon: 'earnings',
                access: true,
                show: false
              },
              {
                name: LeftSidebarData.businessHubParentMenu.partners,
                href: '/partners',
                navIcon: 'partners',
                access: true,
                show: true
              },
              {
                name: LeftSidebarData.businessHubParentMenu.partnerIntroduced,
                href: '/partner-introduced',
                navIcon: 'introduce',
                access: true,
                show: false
              }
            ]
          },
          {
            name: LeftSidebarData.schoolManagementParentMenu.schoolManagement,
            dropDownHref: 'isDropDown',
            navIcon: 'school',
            access: true,
            isDropDown: true,
            subMenu: [
              {
                name: LeftSidebarData.schoolManagementParentMenu.overview,
                href: '/school-dashboard',
                navIcon: 'dashboard',
                access: true,
                show: true
              },
              {
                // Also lights up on /school-management/create and /:id.
                name: LeftSidebarData.schoolManagementParentMenu.manageSchools,
                href: '/school-management',
                navIcon: 'school',
                access: true,
                show: true
              }
            ]
          },
          {
            name: LeftSidebarData.kidsManagementParentMenu.kidsManagement,
            dropDownHref: 'isDropDown',
            navIcon: 'kids',
            access: true,
            isDropDown: true,
            subMenu: [
              {
                name: LeftSidebarData.kidsManagementParentMenu.kidsDashboard,
                href: `/kids-dashboard`,
                navIcon: 'dashboard',
                access: true,
                show: true
              },
              {
                name: LeftSidebarData.kidsManagementParentMenu.kids,
                href: '/kids-list',
                navIcon: 'kids',
                access: true,
                show: true
              },

              {
                name: LeftSidebarData.kidsManagementParentMenu.kidsPods,
                href: '/kids-content-management/kids-pods',
                navIcon: 'pods',
                access: true,
                show: true
              },
              {
                name: LeftSidebarData.kidsManagementParentMenu.affirmation,
                href: '/kids-content-management/affirmation',
                navIcon: 'affirmation',
                access: true,
                show: true
              },
              {
                name: LeftSidebarData.kidsManagementParentMenu.stories,
                href: '/kids-content-management/stories',
                navIcon: 'sleep',
                access: true,
                show: true
              }
            ]
          },
          {
            name: LeftSidebarData.shoorahHealth.shoorahHealth,
            dropDownHref: 'isDropDown',
            navIcon: 'health',
            access: true,
            isDropDown: true,
            subMenu: [
              {
                name: LeftSidebarData.shoorahHealth.Dashboard,
                href: `/health/health-dashboard`,
                navIcon: 'dashboard',
                access: true,
                show: true
              },
              {
                name: LeftSidebarData.shoorahHealth.Fitness,
                href: `/health/health-fitness`,
                navIcon: 'fitness',
                access: true,
                show: true
              },
              {
                name: LeftSidebarData.shoorahHealth.Nutrition,
                href: `/health/health-nutrition`,
                navIcon: 'nutrition',
                access: true,
                show: true
              }
            ]
          },
          {
            name: LeftSidebarData.achievements.achievements,
            dropDownHref: 'isDropDown',
            navIcon: 'badges',
            access: true,
            isDropDown: true,
            subMenu: [
              {
                name: LeftSidebarData.achievements.list,
                href: `/achievements`,
                navIcon: 'badges',
                access: true,
                show: true
              },
              {
                name: LeftSidebarData.achievements.create,
                href: '/achievements/create',
                navIcon: 'create',
                access: true,
                show: true
              }
            ]
          }
        ]);
      }
    }
  }, [
    subsData,
    setSubsData,
    userData?.expertApprove,
    userData?.id,
    userData?.moduleAccess?.earning_module_access,
    userData?.slug,
    userData?.userType,
    showBenefits,
    isB2BFansMode
  ]);

  useEffect(() => {
    if (sidebarData.length) {
      let index = sidebarData.findIndex((data) => {
        if (data.isDropDown && data.subMenu) {
          return data.subMenu.some((subItem) => matchesEntry(location?.pathname, subItem));
        }
        return isPathUnder(location?.pathname, data.href);
      });

      if (index !== -1) {
        for (let i = 0; i <= index; i++) {
          if (!sidebarData[i].access) {
            index--;
          }
        }
      }

      if (index === -1) {
        setActiveIndexAlt(null);
        setActiveIndex(null);
      } else {
        let adjustedIndex = index;

        openedSubMenus.forEach((submenuIndex) => {
          if (submenuIndex < index) {
            const visibleSubMenus = sidebarData[submenuIndex]?.subMenu?.filter(
              (subItem) => subItem.show
            );
            if (visibleSubMenus?.length) {
              adjustedIndex += visibleSubMenus.length + visibleSubMenus.length * 0.12;
            }
          }
        });

        setActiveIndexAlt(adjustedIndex);
      }
    }
  }, [location.pathname, sidebarData, openedSubMenus]);

  //   useEffect(() => {
  //     if (sidebarData.length) {
  //       let index = sidebarData.findIndex((data) => {
  //         if (data.isDropDown && data.subMenu) {
  //           return data.subMenu.some((subItem) => location?.pathname?.includes(subItem.href));
  //         }
  //         return location?.pathname?.includes(data.href);
  //       });
  //       if (index !== -1) {
  //         for (let i = 0; i <= index; i++) {
  //           if (sidebarData[i].access) {
  //             // index--;
  //           } else {
  //             index--;
  //           }
  //         }
  //       }
  //       if (index === -1) {
  //         setActiveIndexAlt(null);
  //         setActiveIndex(null);
  //       } else {
  //         let adjustedIndex = index;
  //         if (openedSubMenuIndex !== null && openedSubMenuIndex < index) {
  //           const visibleSubMenus = sidebarData[openedSubMenuIndex]?.subMenu.filter(
  //             (subItem) => subItem.show
  //           );
  //           adjustedIndex += visibleSubMenus.length + visibleSubMenus.length * 0.12;
  //         }
  //         setActiveIndexAlt(adjustedIndex);
  //       }
  //     }
  //   }, [location.pathname, sidebarData, openedSubMenuIndex]);

  const getCompanyPlanData = useCallback(() => {
    CompanyApi.getCompanyStatus(userData.companyId)
      .then((res) => {
        if (res?.data?.meta.code === 1) {
          setSubsData(res?.data?.data);
        } else {
          return errorToast(LeftSidebarData.errorToastMessage);
        }
      })
      .catch((err) => {
        return errorToast(err);
      });
  }, [userData?.companyId]);

  useEffect(() => {
    if (userData?.userType === 3 || userData?.userType === 4) {
      getCompanyPlanData();
    }
  }, [getCompanyPlanData, userData?.userType]);

  function classNames(...classes) {
    return classes.filter(Boolean).join(' ');
  }

  return (
    <div
      style={{ transition: 'width 0.3s ease-in-out' }}
      className={`flex flex-col overflow-hidden bg-white dark:bg-shoorah-darkBgTabColor md:relative fixed md:top-0 top-[89px] z-40 border-r md:border-r-[1.5px] border-shoorah-borderGray dark:border-shoorah-darkBorder md:h-full ${
        rail ? 'md:w-[76px]' : 'md:w-[250px]'
      } ${slide ? 'w-[300px] h-[calc(100vh-88.8px)]' : 'w-[0px] h-full'}`}
    >
      <div className="h-full w-full flex flex-col">
        <div className="flex shrink-0 flex-col justify-center w-full bg-white dark:bg-shoorah-darkBgTabColor items-center px-2 pt-5 pb-1">
          {/* The wordmark is 140px wide and cannot shrink into a 76px rail, so
              the rail keeps only the control that brings it back. */}
          <div
            className={`flex items-center w-full ${
              rail ? 'justify-center px-0' : 'justify-between px-3'
            }`}
          >
            {!rail && (
              <img className="h-[29px] w-auto dark:invert" src={SidebarLogo} alt="Shoorah" />
            )}
            {canToggle && (
              <button
                type="button"
                onClick={() => setIsCollapsed(!isCollapsed)}
                aria-label={isCollapsed ? 'Expand navigation' : 'Collapse navigation'}
                title={isCollapsed ? 'Expand navigation' : 'Collapse navigation'}
                className="flex items-center justify-center h-8 w-8 rounded-md text-shoorah-gray3 hover:text-shoorah-lightBlack dark:hover:text-white hover:bg-[#F9F9F9] dark:hover:bg-white/10 transition-colors"
              >
                <NavIcon name="panel" className="h-[18px] w-[18px]" />
              </button>
            )}
          </div>
          <div className="h-[1.5px] w-[calc(100%-48px)] mt-4 mb-1 bg-shoorah-borderGray2 dark:bg-shoorah-darkBorder"></div>
        </div>
        <nav className="flex-1 min-h-0 overflow-y-auto hide-scrollbar">
          {sidebarData?.map((item, index) =>
            !item?.access ? (
              ''
            ) : (
              <Menu
                key={index}
                item={item}
                index={index}
                rail={rail}
                setActiveIndex={setActiveIndex}
                // openedSubMenuIndex={openedSubMenuIndex}
                // setOpenedSubMenuIndex={setOpenedSubMenuIndex}
                openedSubMenus={openedSubMenus}
                setOpenedSubMenus={setOpenedSubMenus}
              />
            )
          )}
        </nav>
        <div className="flex shrink-0 justify-center w-full z-50 dark:bg-shoorah-darkBgTabColor items-center px-2 pb-2">
          <div className="flex flex-col justify-center items-center flex-shrink-0 w-full">
            <div className="group flex-shrink-0 h-[1.5px] w-[calc(100%-48px)] mx-6 mb-1 mt-1 bg-shoorah-borderGray2 dark:bg-shoorah-darkBorder"></div>
            <div
              onClick={() => {
                if (rail) setIsDarkModeEnabled(!isDarkModeEnabled);
              }}
              title={rail ? LeftSidebarData.darkMode : undefined}
              className={`group block w-full flex-shrink-0 cursor-pointer py-[18px] ps-[18px] ${
                rail ? 'ps-0 flex justify-center' : ''
              }`}
            >
              <div className={`flex items-center ${rail ? 'justify-center' : 'justify-between'}`}>
                <div className="flex items-center">
                  <img
                    src={darkMoonIcon}
                    alt="sidebar_icon"
                    className={`${
                      rail ? 'mx-0' : 'mr-3 ml-2'
                    } h-6 w-6 flex-shrink-0 dark:block hidden`}
                  />
                  <img
                    src={moonIcon}
                    alt="sidebar_icon"
                    className={`${
                      rail ? 'mx-0' : 'mr-3 ml-2'
                    } h-6 w-6 flex-shrink-0 dark:hidden block`}
                  />
                  {!rail && (
                    <p className="text-sm text-shoorah-lightBlack dark:text-shoorah-darkBg font-medium">
                      {LeftSidebarData.darkMode}
                    </p>
                  )}
                </div>
                <Switch
                  checked={isDarkModeEnabled}
                  onChange={() => {
                    setIsDarkModeEnabled(!isDarkModeEnabled);
                  }}
                  className={classNames(
                    rail ? 'hidden' : '',
                    'mr-3 ml-2 relative border-shoorah-lightBlack dark:border-shoorah-darkBg inline-flex h-4 w-7 flex-shrink-0 cursor-pointer rounded-full border-2 duration-200 ease-in-out focus:outline-none'
                  )}
                >
                  <span
                    aria-hidden="true"
                    className={classNames(
                      isDarkModeEnabled ? 'translate-x-3' : 'translate-x-0',
                      'pointer-events-none inline-block h-3 w-3 transform rounded-full bg-shoorah-lightBlack dark:bg-shoorah-darkBg border-shoorah-darkBg shadow ring-0 transition duration-200 ease-in-out'
                    )}
                  />
                </Switch>
              </div>
            </div>
            {/* B2B/Fans Toggle - Only show for B2B admins */}
            {(userData?.userType === 3 || userData?.userType === 4) && showMemberOptions && (
              <div
                className={`group block w-full flex-shrink-0 cursor-pointer py-[18px] ps-[18px] ${
                  rail ? 'ps-0 flex justify-center' : ''
                }`}
              >
                <div className="flex items-center justify-between">
                  <div className="flex items-center">
                    <img
                      src={darkuserIcon}
                      alt="b2b_fans_icon"
                      className={`${
                        rail ? 'mx-0' : 'mr-3 ml-2'
                      } h-6 w-6 flex-shrink-0 dark:block hidden`}
                    />
                    <img
                      src={userIcon}
                      alt="b2b_fans_icon"
                      className={`${
                        rail ? 'mx-0' : 'mr-3 ml-2'
                      } h-6 w-6 flex-shrink-0 dark:hidden block`}
                    />
                    {!rail && (
                      <p className="text-sm text-shoorah-lightBlack dark:text-shoorah-darkBg font-medium">
                        {isB2BFansMode ? 'Members Mode' : 'B2B Mode'}
                      </p>
                    )}
                  </div>
                  <Switch
                    checked={isB2BFansMode}
                    onChange={() => {
                      setIsB2BFansMode(!isB2BFansMode);
                      // Refresh page after toggle to reload data
                      setTimeout(() => {
                        window.location.reload();
                      }, 100); // Small delay to ensure state is saved
                    }}
                    className={classNames(
                      rail ? 'hidden' : '',
                      'mr-3 ml-2 relative border-shoorah-lightBlack dark:border-shoorah-darkBg inline-flex h-4 w-7 flex-shrink-0 cursor-pointer rounded-full border-2 duration-200 ease-in-out focus:outline-none'
                    )}
                  >
                    <span
                      aria-hidden="true"
                      className={classNames(
                        isB2BFansMode ? 'translate-x-3' : 'translate-x-0',
                        'pointer-events-none inline-block h-3 w-3 transform rounded-full bg-shoorah-lightBlack dark:bg-shoorah-darkBg border-shoorah-darkBg shadow ring-0 transition duration-200 ease-in-out'
                      )}
                    />
                  </Switch>
                </div>
              </div>
            )}
            <div
              className={`group block w-full flex-shrink-0 cursor-pointer py-[18px] ps-[18px] ${
                rail ? 'ps-0 flex justify-center' : ''
              }`}
            >
              <div className="flex items-center" onClick={requestLogout}>
                <img
                  src={logOutIcon}
                  alt="sidebar_icon"
                  className={`${
                    rail ? 'mx-0' : 'mr-3 ml-2'
                  } h-6 w-6 flex-shrink-0 dark:hidden block`}
                />
                <img
                  src={darkLogOutIcon}
                  alt="sidebar_icon"
                  className={`${
                    rail ? 'mx-0' : 'mr-3 ml-2'
                  } h-6 w-6 flex-shrink-0 dark:block hidden`}
                />
                {!rail && (
                  <p className="text-sm text-shoorah-lightBlack dark:text-shoorah-darkBg font-medium">
                    {LeftSidebarData.logOut}
                  </p>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
      {logoutConfirm}
    </div>
  );
}

export default NewSidebar;
